import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import OverflowTooltipContent from '@/component/common/OverflowTooltipContent';
import { cloneDeep } from 'lodash';
import React from 'react';
import Constant from '@/common/constant/Constant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import { LOCAL_MCP_LABEL_PREFIX } from '@/component/mcpCatalog/McpCatalogConstant';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CorporationProvideFunction({
    selectedProduct,
    selectedEdition,
    selectedVersion,
    listProvideFunction = [],
    setListProvideFunction,
    setListInvidualBasic,
    setIsEdit,
    corpActiveIsBlock,
    lincenseKey,
    setLincenseKey,
    setIsChangeLincenseKey,
    isSettingLicenseKeyByCorp,
    rootLicenseKeyValue,
    localMcpList = [],
    setLocalMcpList
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const licenseKeyPermissionData =
        listProvideFunction?.find(
            item =>
                item.label ===
                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION
        ) || null;
    const isOnLicenseKeyPermission = licenseKeyPermissionData?.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON;
    const isInheritKeyFromProduct = !Utils.isEmptyString(selectedProduct?.moduleSetting?.lincenseKeySetting?.key);

    const updateFileTranslationByAIAuto = (provideFunctionList, enabled) => {
        const indexFileTranslation = provideFunctionList.findIndex(
            item =>
                item.label ===
                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_FILE_TRANSLATION
        );

        if (indexFileTranslation === -1) return;

        provideFunctionList[indexFileTranslation].switchCorpDisabled = !enabled;
        provideFunctionList[indexFileTranslation].switchCorporation = enabled
            ? Constant.STATUS_SERVICE_PERMISSION.ON
            : Constant.STATUS_SERVICE_PERMISSION.OFF;
    };

    /**
     * telephoneAgent depends on aiAuto: it can only be used while aiAuto is ON.
     * The toggle stays clickable while aiAuto is OFF (turning it ON forces aiAuto ON),
     * it is only auto-turned-off when aiAuto goes OFF.
     */
    const updateTelephoneAgentByAIAuto = (provideFunctionList, enabled) => {
        if (enabled) return;

        const indexTelephoneAgent = provideFunctionList.findIndex(
            item =>
                item.label ===
                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_TELEPHONE_AGENT
        );

        if (indexTelephoneAgent === -1) return;

        provideFunctionList[indexTelephoneAgent].switchCorporation =
            Constant.STATUS_SERVICE_PERMISSION.OFF;
    };

    /**
     * Reverse side of the dependency above: turning telephoneAgent ON forces aiAuto ON.
     * fileTranslation follows aiAuto only when aiAuto actually flips OFF -> ON;
     * if aiAuto is already ON, telephoneAgent and fileTranslation stay independent.
     */
    const updateAIAutoByTelephoneAgent = (provideFunctionList, telephoneAgentEnabled) => {
        if (!telephoneAgentEnabled) return;

        const indexAIAuto = provideFunctionList.findIndex(
            item => item.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO
        );

        if (indexAIAuto === -1) return;

        const isAIAutoOn =
            provideFunctionList[indexAIAuto].switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON;
        if (isAIAutoOn) return;

        provideFunctionList[indexAIAuto].switchCorporation =
            Constant.STATUS_SERVICE_PERMISSION.ON;
        updateFileTranslationByAIAuto(provideFunctionList, true);
    };

    const onChangeStatusResourceService = e => {
        setIsEdit(true);
        setListProvideFunction(prev => {
            let prevClone = cloneDeep(prev);
            let index = prevClone.findIndex(item => item.label === e.target.id);
            if (index !== -1) {
                switch (e.target.id) {
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_PUBLIC_SERVICE_DESK_SETTINGS:
                        let indexPublicWebForm = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_PUBLIC_WEB_FORM
                        );

                        if (indexPublicWebForm !== -1) {
                            prevClone[indexPublicWebForm].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexPublicWebForm].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        setListInvidualBasic(prevInvidual => {
                            const arrUpdate = [
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_QA_COUNTER,
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_SUPPORTED_COUNTER,
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_B2C
                            ];

                            let invidualUpdate = prevInvidual.map(invidual => {
                                if (arrUpdate.includes(invidual.label)) {
                                    invidual.disabled = !e.target.checked;
                                    if (!e.target.checked) {
                                        invidual.value = '';
                                    }
                                }
                                return invidual;
                            });

                            return invidualUpdate;
                        });

                        break;
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SOLUTIONDESK_KNOWLEDGE:
                        let indexConvertPDF = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_CONVERT_PDF
                        );

                        if (indexConvertPDF !== -1) {
                            prevClone[indexConvertPDF].switchCorpDisabled = !e.target
                                .checked;
                            if (!e.target.checked) {
                                prevClone[indexConvertPDF].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexPublicKnowledgeSite = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_PUBLIC_KNOWLEDGE_SITE
                        );

                        if (indexPublicKnowledgeSite !== -1) {
                            prevClone[indexPublicKnowledgeSite].switchCorpDisabled = !e.target
                                .checked;
                            if (!e.target.checked) {
                                prevClone[indexPublicKnowledgeSite].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexKnowledgeBot = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_KNOWLEDGE_BOT
                        );

                        if (indexKnowledgeBot !== -1) {
                            prevClone[indexKnowledgeBot].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexKnowledgeBot].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexSynonymSearch = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_SYNONYM_SEARCH
                        );

                        if (indexSynonymSearch !== -1) {
                            prevClone[indexSynonymSearch].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexSynonymSearch].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexBatchCommandService = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_BATCH_COMMAND
                        );

                        if (indexBatchCommandService !== -1) {
                            prevClone[indexBatchCommandService].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexBatchCommandService].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        setListInvidualBasic(prevInvidual => {
                            const arrUpdate = [
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_KNOWLEDGE
                            ];

                            let invidualUpdate = prevInvidual.map(invidual => {
                                if (arrUpdate.includes(invidual.label)) {
                                    invidual.disabled = !e.target.checked;
                                    if (!e.target.checked) {
                                        invidual.value = '';
                                    }
                                }
                                return invidual;
                            });

                            return invidualUpdate;
                        });

                        break;
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION:
                        const licenseKeyOfProductObj = selectedProduct?.moduleSetting?.lincenseKeySetting;
                        const isTurnOnLicenseKeySetting = prevClone[index].switchCorpDisabled;
                        let productLicenseKey = '';

                        /**when switch 貸出ライセンスキー利用を許可する OFF -> ON and OpenAIライセンスキー is empty. fill value   OpenAIライセンスキー from product version to value setting in root corp.  */
                        if(!Utils.isEmptyString(licenseKeyOfProductObj?.key)) {
                            productLicenseKey = licenseKeyOfProductObj?.key
                        }

                        if (
                            e.target.checked &&
                            !isTurnOnLicenseKeySetting &&
                            Utils.isEmptyString(lincenseKey?.value)
                        ) {
                            let errorLincenseKey = '';
                            if (!productLicenseKey) {
                                errorLincenseKey = trI18n('MSG-CM-REQUIRED-INPUT');
                            }
                            setLincenseKey(prevSetLincenseKey => {
                                return {
                                    ...prevSetLincenseKey,
                                    value: productLicenseKey,
                                    error: errorLincenseKey
                                };
                            });
                            setIsChangeLincenseKey(true);
                            if (e.target.checked && Utils.isEmptyString(productLicenseKey)) {
                                setIsEdit(false);
                            }
                        //.end
                        } else {
                            // When switch off and root setting license key is not empty, set value to root setting license key
                            // if root setting license key is empty, set value to empty
                            setLincenseKey(prevSetLincenseKey => {
                                return {
                                    ...prevSetLincenseKey,
                                    value: rootLicenseKeyValue,
                                    error: ''
                                };
                            });

                            if (e.target.checked && Utils.isEmptyString(lincenseKey?.value)) {
                                setIsEdit(false);
                            }
                        }
                        break;
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI:{
                        let indexLicenseKey = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_LINCENSE_KEY_PERMISSION
                        );

                        const idxExternalAPI = prevClone.findIndex(
                            item =>
                                item?.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_EXTERNAL_WEB_API
                        );

                        const idxSDAuto = prevClone.findIndex(
                            i =>
                                i?.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SD_AUTO
                        );

                        const idxMCPServer = prevClone.findIndex(
                            i =>
                                i?.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_MCP_SERVER
                        );
                        const indexAIAuto = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO
                        );

                        const indexTelephoneAgent = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_TELEPHONE_AGENT
                        );

                        if (indexLicenseKey !== -1) {
                            prevClone[indexLicenseKey].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexLicenseKey].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                                setLincenseKey(prevLincenKey => ({
                                    ...prevLincenKey,
                                    error: ''
                                }));
                            }
                        }

                        if (indexAIAuto !== -1) {
                            prevClone[indexAIAuto].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexAIAuto].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        if (idxExternalAPI !== -1) {
                            prevClone[idxExternalAPI].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[idxExternalAPI].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        if(idxSDAuto !== -1) {
                            prevClone[idxSDAuto].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[idxSDAuto].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        if(idxMCPServer !== -1) {
                            prevClone[idxMCPServer].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[idxMCPServer].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                                // Cascade: mcpServer OFF → all local MCP catalog OFF + disable
                                setLocalMcpList(prevList =>
                                    prevList.map(item => ({
                                        ...item,
                                        switchCorporation: 0,
                                        switchCorpDisabled: true
                                    }))
                                );
                            } else {
                                // mcpServer enabled → enable local MCP catalog toggles
                                setLocalMcpList(prevList =>
                                    prevList.map(item => ({
                                        ...item,
                                        switchCorpDisabled: false
                                    }))
                                );
                            }
                        }
                        
                        if (indexTelephoneAgent !== -1) {
                            prevClone[indexTelephoneAgent].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexTelephoneAgent].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        const indexKBoard = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_K_BOARD
                        );

                        if (indexKBoard !== -1) {
                            prevClone[indexKBoard].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexKBoard].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        const isAIAutoOn =
                            indexAIAuto !== -1 &&
                            prevClone[indexAIAuto].switchCorporation ===
                                Constant.STATUS_SERVICE_PERMISSION.ON;
                        updateFileTranslationByAIAuto(prevClone, e.target.checked && isAIAutoOn);
                        updateTelephoneAgentByAIAuto(prevClone, e.target.checked && isAIAutoOn);

                        break;
                    }
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO: {
                        updateFileTranslationByAIAuto(prevClone, e.target.checked);
                        updateTelephoneAgentByAIAuto(prevClone, e.target.checked);

                        break;
                    }
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_TELEPHONE_AGENT: {
                        updateAIAutoByTelephoneAgent(prevClone, e.target.checked);

                        break;
                    }
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_MCP_SERVER: {
                        // mcpServer OFF → all local MCP catalog OFF + disable
                        if (!e.target.checked) {
                            setLocalMcpList(prevList =>
                                prevList.map(item => ({
                                    ...item,
                                    switchCorporation: 0,
                                    switchCorpDisabled: true
                                }))
                            );
                        } else {
                            // mcpServer ON → enable local MCP catalog toggles (keep current value)
                            setLocalMcpList(prevList =>
                                prevList.map(item => ({
                                    ...item,
                                    switchCorpDisabled: false
                                }))
                            );
                        }
                        break;
                    }
                    default:
                        break;
                }

                prevClone[index].switchCorporation = e.target.checked
                    ? Constant.STATUS_SERVICE_PERMISSION.ON
                    : Constant.STATUS_SERVICE_PERMISSION.OFF;
            }
            return prevClone;
        });
    };

    let text = `${selectedProduct.label} ${selectedEdition.label} (${selectedVersion.label})`;

    const handleDisableLincenseKeyInput = () => {
        let isPermissionLincenseKeyOn = false;
        let permissionKeyData = listProvideFunction.find(funct => funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION);
        if (permissionKeyData && permissionKeyData.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isPermissionLincenseKeyOn = true;
        }
        let isChatAiOn = false;
        let chatAiData = listProvideFunction.find(funct => funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI);
        if (chatAiData && chatAiData.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isChatAiOn = true;
        }
        return !(isChatAiOn && isPermissionLincenseKeyOn);
    };

    const handleChangeInputLincenseKey = (e) => {
        let lincenseKeyValue = e.target.value.trim();
        setIsEdit(true);
        setIsChangeLincenseKey(true);

        let errorLincenseKey = '';
        // When input empty and product license key is empty, show error
        if (
            Utils.isEmptyString(lincenseKeyValue) &&
            !selectedProduct?.moduleSetting?.lincenseKeySetting?.key &&
            isOnLicenseKeyPermission
        ) {
            errorLincenseKey = trI18n('MSG-CM-REQUIRED-INPUT');
        }
        setLincenseKey(prev => {
            return {
                ...prev,
                value: lincenseKeyValue,
                error: errorLincenseKey
            };
        });
    };

    const isSettingAIOn = () => {
        let isAIOn = false;

        let aiData = listProvideFunction.find(
            funct =>
                funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI
        );
        if (aiData && aiData.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isAIOn = true;
        }

        return isAIOn;
    };

    const isSettingAIAutoOn = () => {
        let aiAutoData = listProvideFunction.find(
            funct =>
                funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO
        );

        return aiAutoData?.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON;
    };

    return (
        <>
            <div className="pl-16 pr-16 head-title-provide">
                <span>{tr('提供機能:')}</span>
                <OverFlowTooltipWithTabsMui value={text} className="name-info-product" />
            </div>

            <div className="table-head-provide">
                <div></div>
                <div>
                    <div>{tr('基本設定')}</div>
                    <div>{tr('個別設定')}</div>
                </div>
            </div>
            
            {!Utils.isEmptyArray(listProvideFunction) &&
                listProvideFunction?.map(provide => {
                    switch (provide.label) {
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI:
                            return (
                                <div
                                    className={`${provide.usedToCustomize &&
                                        provide.switchCorporationDefault != provide.switchVersion &&
                                        'item-provide-background'} item-provide setting-item`}
                                    key={provide.label}
                                >
                                    <div>{trI18n(provide?.label)}</div>
                                    <div>
                                        <div className="switch-check">
                                            <input
                                                id={`${provide?.label}-version`}
                                                type="checkbox"
                                                checked={provide?.switchVersion}
                                                disabled
                                            />
                                            <label htmlFor={`${provide?.label}-version`}></label>
                                        </div>
                                        <div className="switch-check">
                                            <input
                                                id={provide?.label}
                                                type="checkbox"
                                                checked={provide?.switchCorporation}
                                                // checked={checked}
                                                disabled={
                                                    provide?.switchCorpDisabled || corpActiveIsBlock
                                                }
                                                onChange={e => onChangeStatusResourceService(e)}
                                            />
                                            <label htmlFor={provide?.label}></label>
                                        </div>
                                    </div>
                                </div>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION:
                            return (
                                <>
                                    {(
                                        <div className={`${provide.usedToCustomize &&
                                            provide.switchCorporationDefault != provide.switchVersion &&
                                            'item-provide-background'} setting-item-ai-key lincenseKey`} key={provide.label} >
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label>{trI18n(provide?.label)}</label>
                                                <div className='item-provide-license-permission'>
                                                    <div className="switch-check">
                                                        <input
                                                            id={`${provide?.label}-version`}
                                                            type="checkbox"
                                                            checked={provide?.switchVersion}
                                                            disabled
                                                        />
                                                        <label htmlFor={`${provide?.label}-version`}></label>
                                                    </div>
                                                    <div className="switch-check">
                                                        <input
                                                            id={provide?.label}
                                                            type="checkbox"
                                                            checked={provide?.switchCorporation}
                                                            // checked={checked}
                                                            disabled={
                                                                provide?.switchCorpDisabled ||
                                                                corpActiveIsBlock ||
                                                                !isSettingAIOn()
                                                            }
                                                            onChange={e =>
                                                                onChangeStatusResourceService(e)
                                                            }
                                                        />
                                                        <label htmlFor={provide?.label}></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="setting-children-item lincenseKey-input-label">
                                                <label className="setting-label">{tr(ProductManagementConstant.TEXTBOX_SETTING_LINCENSE_KEY)}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                            <TextField
                                                className="form-control-input form-control-wrapInput form-control-hg32 lincenseKey-input-version"
                                                variant="outlined"
                                                spellCheck={false}
                                                type="text"
                                                value={lincenseKey?.value}
                                                disabled={handleDisableLincenseKeyInput()}
                                                onChange={e => handleChangeInputLincenseKey(e)}
                                                onWheel={e => e.target.blur()}
                                                helperText={lincenseKey?.error}
                                                error={!Utils.isEmptyString(lincenseKey?.error)}
                                            />
                                            </div>
                                            {!Utils.isEmptyString(rootLicenseKeyValue) && <div style={{display: 'flex'}}>
                                                <div className="setting-children-item line-stream"></div>
                                                <p style={{color: 'green', marginTop: '3px'}}>{trI18n('MSG-ORG-CUSTOM-LICENSE-KEY-NOTIFICATION')}</p>
                                            </div>}
                                            {isInheritKeyFromProduct && <div style={{display: 'flex'}}>
                                                <div className="setting-children-item line-stream"></div>
                                                <p style={{color: 'green', marginTop: '3px'}}>{trI18n('MSG-ORG-INHERIT-LICENSE-KEY-FROM-PRODUCT')}</p>
                                            </div>}
                                            {isSettingLicenseKeyByCorp && <div style={{display: 'flex'}}>
                                                <div className="setting-children-item line-stream"></div>
                                                <p style={{color: 'green'}}>{trI18n('LABEL-USING-YOUR-ORG-LICENSE-KEY')}</p>
                                            </div>}
                                        </div>
                                    )}
                                </>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO:
                            return (
                                <>
                                    {
                                        <div
                                            className={`${provide.usedToCustomize &&
                                                provide.switchCorporationDefault !==
                                                    provide.switchVersion &&
                                                'item-provide-background'} setting-item-ai-auto lincenseKey`}
                                            key={provide.label}
                                        >
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label>{trI18n(provide?.label)}</label>
                                                <div className="item-provide-license-permission">
                                                    <div className="switch-check">
                                                        <input
                                                            id={`${provide?.label}-version`}
                                                            type="checkbox"
                                                            checked={provide?.switchVersion}
                                                            disabled
                                                        />
                                                        <label htmlFor={`${provide?.label}-version`}>
                                                            <span className="field-hidden">
                                                                {provide?.label}
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="switch-check">
                                                        <input
                                                            id={provide?.label}
                                                            type="checkbox"
                                                            checked={provide?.switchCorporation}
                                                            disabled={
                                                                provide?.switchCorpDisabled ||
                                                                corpActiveIsBlock ||
                                                                !isSettingAIOn()
                                                            }
                                                            onChange={e =>
                                                                onChangeStatusResourceService(e)
                                                            }
                                                        />
                                                        <label htmlFor={provide?.label}>
                                                            <span className="field-hidden">
                                                                {provide?.label}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="line-stream"></div>
                                        </div>
                                    }
                                </>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SD_AUTO:
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_TELEPHONE_AGENT:
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_FILE_TRANSLATION:
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_K_BOARD: {
                            const isFileTranslation =
                                provide.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_FILE_TRANSLATION;
                            return (
                                <>
                                    {
                                        <div
                                            className={`${provide.usedToCustomize &&
                                                provide.switchCorporationDefault !==
                                                    provide.switchVersion &&
                                                'item-provide-background'} setting-item-ai-auto lincenseKey`}
                                            key={provide.label}
                                        >
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label>{trI18n(provide?.label)}</label>
                                                <div className="item-provide-license-permission">
                                                    <div className="switch-check">
                                                        <input
                                                            id={`${provide?.label}-version`}
                                                            type="checkbox"
                                                            checked={provide?.switchVersion}
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor={`${provide?.label}-version`}
                                                        >
                                                            <span className="field-hidden">
                                                                {provide?.label}
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="switch-check">
                                                        <input
                                                            id={provide?.label}
                                                            type="checkbox"
                                                            checked={provide?.switchCorporation}
                                                            disabled={
                                                                provide?.switchCorpDisabled ||
                                                                corpActiveIsBlock ||
                                                                !isSettingAIOn() ||
                                                                (isFileTranslation && !isSettingAIAutoOn())
                                                            }
                                                            onChange={e =>
                                                                onChangeStatusResourceService(e)
                                                            }
                                                        />
                                                        <label htmlFor={provide?.label}>
                                                            <span className="field-hidden">
                                                                {provide?.label}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="line-stream"></div>
                                        </div>
                                    }
                                </>
                            ); 
                        }
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_MCP_SERVER:
                            return (
                                <>
                                    {
                                        <div
                                            className={`${provide.usedToCustomize &&
                                                provide.switchCorporationDefault !==
                                                    provide.switchVersion &&
                                                'item-provide-background'} setting-item-ai-auto lincenseKey`}
                                            key={provide.label}
                                        >
                                            <div className="setting-children-item">
                                                <label>{trI18n(provide?.label)}</label>
                                                <div className="item-provide-license-permission">
                                                    <div className="switch-check">
                                                        <input
                                                            id={`${provide?.label}-version`}
                                                            type="checkbox"
                                                            checked={provide?.switchVersion}
                                                            disabled
                                                        />
                                                        <label
                                                            htmlFor={`${provide?.label}-version`}
                                                        >
                                                            <span className="field-hidden">
                                                                {provide?.label}
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="switch-check">
                                                        <input
                                                            id={provide?.label}
                                                            type="checkbox"
                                                            checked={provide?.switchCorporation}
                                                            disabled={
                                                                provide?.switchCorpDisabled ||
                                                                corpActiveIsBlock ||
                                                                !isSettingAIOn()
                                                            }
                                                            onChange={e =>
                                                                onChangeStatusResourceService(e)
                                                            }
                                                        />
                                                        <label htmlFor={provide?.label}>
                                                            <span className="field-hidden">
                                                                {provide?.label}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {/* Local MCP sub-list - indented under 外部連携, no line-stream */}
                                    {localMcpList.length > 0 && localMcpList.map(mcpItem => (
                                        <div className={`${mcpItem?.usedToCustomize &&
                                                'item-provide-background'} local-mcp-item setting-item`} key={mcpItem.catId} style={{ border: 'none', paddingLeft: '56px' }}>
                                            <label className="setting-label local-mcp-label" style={{ border: 'none', paddingLeft: '26px', maxWidth: '250px',  overflow: 'hidden' }}>
                                                <OverflowTooltipContent text={`${LOCAL_MCP_LABEL_PREFIX}${mcpItem.mcpName}`} />
                                            </label>
                                            <div className="item-provide-license-permission">
                                                <div className="switch-check">
                                                    <input
                                                        id={`local-mcp-version-${mcpItem.catId}`}
                                                        type="checkbox"
                                                        checked={mcpItem.switchVersion}
                                                        disabled
                                                    />
                                                    <label htmlFor={`local-mcp-version-${mcpItem.catId}`}>
                                                        <span className="field-hidden">{mcpItem.mcpName}</span>
                                                    </label>
                                                </div>
                                                <div className="switch-check">
                                                    <input
                                                        id={`local-mcp-corp-${mcpItem.catId}`}
                                                        type="checkbox"
                                                        checked={mcpItem.switchCorporation}
                                                        disabled={
                                                            corpActiveIsBlock ||
                                                            !isSettingAIOn() ||
                                                            !provide?.switchCorporation
                                                        }
                                                        onChange={() => {
                                                            setIsEdit(true);
                                                            setLocalMcpList(prev =>
                                                                prev.map(item =>
                                                                    item.catId === mcpItem.catId
                                                                        ? { ...item, switchCorporation: item.switchCorporation ? 0 : 1 }
                                                                        : item
                                                                )
                                                            );
                                                        }}
                                                    />
                                                    <label htmlFor={`local-mcp-corp-${mcpItem.catId}`}>
                                                        <span className="field-hidden">{mcpItem.mcpName}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_EXTERNAL_WEB_API:
                            return (
                                <div
                                    className={`${provide.usedToCustomize &&
                                        provide.switchCorporationDefault !==
                                            provide.switchVersion &&
                                        'item-provide-background'} setting-item-ai-auto border-bottom lincenseKey`}
                                    key={provide.label}
                                >
                                    <div className="setting-children-item lincenseKeyPermission-item">
                                        <label>{trI18n(provide?.label)}</label>
                                        <div className="item-provide-license-permission">
                                            <div className="switch-check">
                                                <input
                                                    id={`${provide?.label}-version`}
                                                    type="checkbox"
                                                    checked={provide?.switchVersion}
                                                    disabled
                                                />
                                                <label htmlFor={`${provide?.label}-version`}>
                                                    <span className="field-hidden">
                                                        {provide?.label}
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="switch-check">
                                                <input
                                                    id={provide?.label}
                                                    type="checkbox"
                                                    checked={provide?.switchCorporation}
                                                    disabled={
                                                        provide?.switchCorpDisabled ||
                                                        corpActiveIsBlock
                                                    }
                                                    onChange={e => onChangeStatusResourceService(e)}
                                                />
                                                <label htmlFor={`${provide?.label}`}>
                                                    <span className="field-hidden">
                                                        {provide?.label}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_MULTI_LANGUAGE:
                            return (
                                <div
                                    className={`${provide.usedToCustomize &&
                                        provide.switchCorporationDefault != provide.switchVersion &&
                                        'item-provide-background'} item-provide border-top`}
                                    key={provide.label}
                                >
                                    <div>{trI18n(provide?.label)}</div>
                                    <div>
                                        <div className="switch-check">
                                            <input
                                                id={`${provide?.label}-version`}
                                                type="checkbox"
                                                checked={provide?.switchVersion}
                                                disabled
                                            />
                                            <label htmlFor={`${provide?.label}-version`}></label>
                                        </div>
                                        <div className="switch-check">
                                            <input
                                                id={provide?.label}
                                                type="checkbox"
                                                checked={provide?.switchCorporation}
                                                disabled={
                                                    provide?.switchCorpDisabled || corpActiveIsBlock
                                                }
                                                onChange={e => onChangeStatusResourceService(e)}
                                            />
                                            <label htmlFor={provide?.label}></label>
                                        </div>
                                    </div>
                                </div>
                            );
                        default:
                            return (
                                <div
                                    className={`${provide.usedToCustomize &&
                                        provide.switchCorporationDefault != provide.switchVersion &&
                                        'item-provide-background'} item-provide`}
                                    key={provide.label}
                                >
                                    <div>{trI18n(provide?.label)}</div>
                                    <div>
                                        <div className="switch-check">
                                            <input
                                                id={`${provide?.label}-version`}
                                                type="checkbox"
                                                checked={provide?.switchVersion}
                                                disabled
                                            />
                                            <label htmlFor={`${provide?.label}-version`}></label>
                                        </div>
                                        <div className="switch-check">
                                            <input
                                                id={provide?.label}
                                                type="checkbox"
                                                checked={provide?.switchCorporation}
                                                // checked={checked}
                                                disabled={
                                                    provide?.switchCorpDisabled || corpActiveIsBlock
                                                }
                                                onChange={e => onChangeStatusResourceService(e)}
                                            />
                                            <label htmlFor={provide?.label}></label>
                                        </div>
                                    </div>
                                </div>
                            );
                    }
                })}
        </>
    );
}

CorporationProvideFunction.propTypes = {
    selectedProduct: PropTypes.any,
    selectedEdition: PropTypes.any,
    selectedVersion: PropTypes.any,
    listProvideFunction: PropTypes.any,
    setListProvideFunction: PropTypes.any,
    setListInvidualBasic: PropTypes.any,
    setIsEdit: PropTypes.any,
    corpActiveIsBlock: PropTypes.any,
    lincenseKey: PropTypes.any,
    setLincenseKey: PropTypes.any,
    setIsChangeLincenseKey: PropTypes.any,
    isSettingLicenseKeyByCorp: PropTypes.any,
    rootLicenseKeyValue: PropTypes.any
}
